function PropertyDetails({ property, onNavigate }) {
  return (
    <div className="section-wrap space-y-8 py-10 lg:py-14">
      <section className="overflow-hidden rounded-3xl border border-obsidian-200">
        <div className="relative">
          <img src={property.image} alt={property.title} className="h-[360px] w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-obsidian-950/85 via-obsidian-900/35 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-10">
            <button
              className="rounded-full border border-cream-100/50 px-4 py-2 text-sm font-semibold text-cream-50"
              onClick={() => onNavigate("/properties")}
            >
              Back to properties
            </button>
            <h1 className="mt-4 font-serif text-5xl text-cream-50">{property.title}</h1>
            <p className="mt-3 max-w-3xl text-sm leading-7 text-cream-100/95">{property.description}</p>
          </div>
        </div>
      </section>

      <section className="grid gap-6 lg:grid-cols-3">
        <article className="premium-panel p-6">
          <h2 className="font-serif text-3xl text-obsidian-950">Investment Metrics</h2>
          <div className="mt-4 space-y-2 text-sm text-obsidian-800">
            <p>Asking Price: {property.price}</p>
            <p>CAP Rate: {property.capRate}</p>
            <p>Net Rent: {property.netRent}</p>
          </div>
        </article>

        <article className="premium-panel p-6">
          <h2 className="font-serif text-3xl text-obsidian-950">Lease and Tenant</h2>
          <div className="mt-4 space-y-2 text-sm text-obsidian-800">
            <p>Tenant: {property.tenant}</p>
            <p>Lease Term: {property.leaseTerm}</p>
            <p>Lease Type: {property.rentType}</p>
            
          </div>
        </article>

        <article className="premium-panel p-6">
          <h2 className="font-serif text-3xl text-obsidian-950">Property Facts</h2>
          <div className="mt-4 space-y-2 text-sm text-obsidian-800">
            <p>Location: {property.location}</p>
            <p>State: {property.state}</p>
            <p>Year Built: {property.yearBuilt}</p>
            <p>Property ID: {property.propertyId || property.id}</p>
          </div>
        </article>
      </section>

      <section className="premium-panel p-8 text-center sm:p-10">
        <h2 className="font-serif text-4xl text-obsidian-950">Contact Us About This Property</h2>
        <p className="mt-3 text-sm leading-7 text-obsidian-700">
          Request the underwriting package, rent roll summary, and guidance from our investor
          advisory team.
        </p>
        <button
          onClick={() => onNavigate("/contact")}
          className="mt-5 rounded-2xl bg-obsidian-950 px-6 py-3 text-sm font-semibold text-cream-50 transition hover:bg-obsidian-800"
        >
          Request Deal Package
        </button>
      </section>
    </div>
  );
}

export default PropertyDetails;
